<app-loader></app-loader>

<div id="wrapper">
  <ul *ngIf="showSidebar" class="navbar-nav bg-gradient-primary sidebar sidebar-dark">
    <li class="nav-item mb-0">
      <a class="nav-link collapsed">
        <i class="fas fa-fw"></i>
        <span>item.title</span>
      </a>
    </li>
  </ul>

  <app-menu *ngIf="showSidebar" class="fixed-menu shadow"></app-menu>

  <!-- TODO inicializador do menu de convite -->
  <app-invite-link></app-invite-link>

  <div id="content-wrapper" class="d-flex flex-column">

    <div id="content">

      <app-navbar *ngIf="showNavbar" [profile]="user"></app-navbar>
      <div class="container-fluid" style="margin-top: 85px;">
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-footer *ngIf="showFooter"></app-footer>

  </div>

</div>

<a class="scroll-to-top rounded" href="#page-top">
  <i class="fas fa-angle-up"></i>
</a>
